// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__U4hJC","right":"Footer_right__iYQak","buttons":"Footer_buttons__2qVGb"};